import { Snackbar, SNACKBAR_TYPES } from "@lysaab/ui-2";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
const breakdowns = {
    age_validation: (React.createElement(FormattedMessage, { id: "onfido.status.id.non_cleared.age_validation" })),
    compromised_document: (React.createElement(FormattedMessage, { id: "onfido.status.id.non_cleared.compromised_document" })),
    data_comparison: (React.createElement(FormattedMessage, { id: "onfido.status.id.non_cleared.data_comparison" })),
    data_consistency: (React.createElement(FormattedMessage, { id: "onfido.status.id.non_cleared.data_consistency" })),
    data_validation: (React.createElement(FormattedMessage, { id: "onfido.status.id.non_cleared.data_validation" })),
    image_integrity: (React.createElement(FormattedMessage, { id: "onfido.status.id.non_cleared.image_integrity" })),
    police_record: (React.createElement(FormattedMessage, { id: "onfido.status.id.non_cleared.police_record" })),
    visual_authenticity: (React.createElement(FormattedMessage, { id: "onfido.status.id.non_cleared.visual_authenticity" })),
    face_comparison: (React.createElement(FormattedMessage, { id: "onfido.status.id.non_cleared.face_comparison" })),
};
export const NonClearedBreakdownList = ({ idStatus }) => {
    const intl = useIntl();
    const getName = (type, name) => {
        return type.hasOwnProperty(name)
            ? type[name]
            : intl.formatMessage({ id: "onfido.status.id.non_cleared.consider" }) +
                " " +
                name.replaceAll("_", " ");
    };
    if (idStatus.nonClearedBreakdowns.length) {
        return (React.createElement("ul", { className: "snackbar-wrapper" }, idStatus.nonClearedBreakdowns.map((breakdown) => {
            return (React.createElement(Snackbar, { type: SNACKBAR_TYPES.ERROR, icon: true, key: breakdown.name },
                React.createElement("li", { key: breakdown.name }, getName(breakdowns, breakdown.name))));
        })));
    }
    return null;
};
